import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/lib/i18n";
import Footer from "@/components/landing/Footer";

export default function LegalLayout({ titleKey, children, testid }) {
  const { t } = useLanguage();

  useEffect(() => {
    if (typeof window !== "undefined") window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="min-h-screen bg-[#F9F8F6] text-[#0F172A] font-body"
      data-testid={testid}
    >
      <header className="border-b border-slate-200 bg-[#F9F8F6]/90 backdrop-blur sticky top-0 z-40">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-sm text-[#475569] hover:text-[#0B2545] transition"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>{t("legal.backHome")}</span>
          </Link>
          <span className="font-sans-display font-semibold tracking-tight text-[#0B2545] text-sm">
            AI METABOLIC
          </span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 lg:px-8 py-12 sm:py-16">
        <h1 className="font-sans-display text-3xl sm:text-4xl text-[#0B2545] tracking-tight leading-tight mb-2">
          {t(titleKey)}
        </h1>
        <p className="text-xs uppercase tracking-[0.18em] text-[#475569] font-sans-display mb-10">
          {t("legal.lastUpdated")}
        </p>

        <div className="prose-legal space-y-6 text-[#1f2937] leading-relaxed text-[15px]">
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
}
